import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Badge compatti FB / IG per lista e calendario.
 * @param {string[]|undefined} targets
 */
export default function SocialTargetBadges({ targets, className = '' }) {
  const { t } = useTranslation();
  const list = Array.isArray(targets) ? targets : [];
  if (list.length === 0) {
    return null;
  }

  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`}>
      {list.includes('facebook') && (
        <span
          className="text-[8px] font-bold uppercase px-1 py-px rounded bg-[#1877F2] text-white leading-none"
          title={t('gym.social.posts.targetFacebook')}
        >
          FB
        </span>
      )}
      {list.includes('instagram') && (
        <span
          className="text-[8px] font-bold uppercase px-1 py-px rounded bg-gradient-to-r from-[#f58529] via-[#dd2a7b] to-[#8134af] text-white leading-none"
          title={t('gym.social.posts.targetInstagram')}
        >
          IG
        </span>
      )}
    </span>
  );
}
